<template>
	<div class="card">
		<div class="card-header bg-dark">
			<h3 class="mb-0 text-white">
				รายการแนะนำเพื่อน <small>({{ data.length }} ครั้ง)</small>
			</h3>
		</div>

		<el-table row-key="id" header-row-class-name="thead-light" :data="queriedData">
			<el-table-column label="สมาชิก (ผู้แนะนำ)" min-width="75px">
				<div slot-scope="{ row }">
					<router-link :to="`/dashboard/members?search=${row.upline.phone}`">
						{{ row.upline.firstName }} {{ row.upline.lastName }}
					</router-link>
					<br />
					{{ row.upline.phone }}
				</div>
			</el-table-column>
			<el-table-column label="สมาชิก (เติมเงิน)" min-width="75px">
				<div slot-scope="{ row }">
					<router-link :to="`/dashboard/members?search=${row.downline.phone}`">
						{{ row.downline.firstName }} {{ row.downline.lastName }}
					</router-link>
					<br />
					{{ row.downline.phone }}
				</div>
			</el-table-column>
			<el-table-column label="จำนวน" min-width="100px">
				<div slot-scope="{ row }">
					<b>{{ row.amount | format }}</b> บาท
				</div>
			</el-table-column>
			<el-table-column label="วันที่/เวลา" min-width="100px">
				<div slot-scope="{ row }">
					{{ row.createdAt | moment('DD/MM/YYYY HH:mm') }}
				</div>
			</el-table-column>
		</el-table>

		<div class="card-footer border-0 d-flex justify-content-between">
			<p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>

			<base-pagination :per-page="pagination.perPage" :total="total" v-model="pagination.currentPage" />
		</div>
	</div>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui'
import { BasePagination } from '../../components'

import moment from 'moment'
import BonusService from '../../services/bonus.service'
import tablePagination from '../../mixins/tablePagination'

export default {
	props: ['data'],
	mixins: [tablePagination([], 10)],
	components: {
		BasePagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	created() {
		this.updateTableData(this.data)
	},
	watch: {
		data(v) {
			this.updateTableData(v)
		},
	},
}
</script>
